/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import UnitEnum from 'astro/enum/unit';
import EntityEnum from 'astro/enum/entity';

import BasicUnit from 'astro/server/unit/basic';
import Infantry from 'astro/server/unit/infantry';
import Rangers from 'astro/server/unit/rangers';
import Outpost from 'astro/server/unit/outpost';
import RocketLauncher from 'astro/server/unit/rocket.launcher';
import ShieldDome from 'astro/server/unit/shield.dome';
import Gate from 'astro/server/unit/gate';


export default class
{
  constructor (parent, entities)
  {
    this.parent = parent;

    this.collection = new Map();

    for (const cass of entities.values())
    {
      this.collection.set(cass.zone, this.makeEntity(cass, parent));
    }
  }


  makeEntity (cass, parent)
  {
    switch (cass.variant)
    {
      case UnitEnum.Infantry:       return new Infantry(cass, parent);
      case UnitEnum.Rangers:        return new Rangers(cass, parent);
      case UnitEnum.Outpost:        return new Outpost(cass, parent);
      case UnitEnum.Artillery:      return new BasicUnit(cass, parent);
      case UnitEnum.AssaultTroops:  return new BasicUnit(cass, parent);
      case UnitEnum.MechInfantry:   return new BasicUnit(cass, parent);
      case UnitEnum.SpecialForces:  return new BasicUnit(cass, parent);
      case UnitEnum.RocketLauncher: return new RocketLauncher(cass, parent);
      case UnitEnum.ShieldDome:     return new ShieldDome(cass, parent);
      case UnitEnum.Gate:           return new Gate(cass, parent);
    }

    throw new Error('Unexpected entity variant found: ' + cass.variant);
  }


  setup ()
  {
    for (const entity of this.collection.values())
    {
      entity.setup();
    }
  }


  setupInstaller (installer)
  {
    for (const entity of this.collection.values())
    {
      installer.pushEntity(entity);
    }
  }


  getEntity (zoneID)
  {
    return this.collection.get(zoneID);
  }


  getBuilding (zoneID)
  {
    const entity = this.getEntity(zoneID);

    return entity && entity.getCass().type === EntityEnum.Building ? entity : null;
  }


  getUnit (zoneID)
  {
    const entity = this.getEntity(zoneID);

    return entity && entity.getCass().type === EntityEnum.Unit ? entity : null;
  }


  getBuildingByType (userID, type)
  {
    for (const entity of this.collection.values())
    {
      if (entity.getCass().type === EntityEnum.Building)
      {
        if (entity.getUserID() === userID && entity.getType() === type)
        {
          return entity;
        }
      }
    }

    return null;
  }


  getActiveConstruction (userID)
  {
    for (const entity of this.collection.values())
    {
      const status = entity.getStatus();

      if (entity.getCass().type === EntityEnum.Building)
      {
        if ((status.isConstruction() || status.isUpgrade()) && entity.getUserID() === userID)
        {
          return entity;
        }
      }
    }

    return null;
  }


  canConstructBuilding (userID)
  {
    for (const sector of this.parent.getSectors().getAll())
    {
      if (sector.getUser().getID() === userID && sector.getBuilding() == null)
      {
        return true;
      }
    }

    return false;
  }


}
